import { Camera, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { MAX_FILES, MAX_FILE_MB } from "./wizardOptions";

export const PhotoUpload = ({ uploads, setUploads, label = "Foto's van uw huidige kozijnen", note = "(optioneel)", cta = "Foto's kiezen of maken",
  max = MAX_FILES, testid = "wizard-photo", icon: Icon = Camera, onUploaded }) => {
  const handleFiles = async (files) => {
    const list = Array.from(files || []).slice(0, max - uploads.length);
    for (const f of list) {
      if (f.size > MAX_FILE_MB * 1024 * 1024) { toast.error(`${f.name} is groter dan ${MAX_FILE_MB} MB`); continue; }
      const id = Math.random().toString(36).slice(2);
      setUploads((u) => [...u, { id, name: f.name, path: null }]);
      try {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        setUploads((u) => u.map((x) => (x.id === id ? { ...x, path: data.path } : x)));
        onUploaded?.(f);
      } catch (err) {
        setUploads((u) => u.filter((x) => x.id !== id));
        toast.error(err?.response?.data?.detail || `Upload mislukt: ${f.name}`);
      }
    }
  };

  return (
    <div>
      <p className="mb-2.5 text-[14px] font-semibold text-ink">{label} {note && <span className="font-normal text-slate-500">{note}</span>}</p>
      {uploads.length < max && (
        <label className="flex cursor-pointer flex-col items-center rounded-xl border-2 border-dashed border-slate-300 bg-slate-50/60 px-4 py-6 text-center transition-colors hover:border-maas hover:bg-maas-soft/40" data-testid={`${testid}-dropzone`}>
          <input type="file" accept="image/jpeg,image/png,image/webp,image/heic,image/heif,application/pdf" multiple className="sr-only"
            onChange={(e) => { handleFiles(e.target.files); e.target.value = ""; }} data-testid={`${testid}-input`} />
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-maas ring-1 ring-slate-200"><Icon className="h-5 w-5" aria-hidden="true" /></span>
          <span className="mt-2.5 text-[15px] font-semibold text-ink">{cta}</span>
          <span className="mt-0.5 text-[13px] text-slate-500">JPG, PNG, HEIC of PDF · max {MAX_FILE_MB} MB · tot {max} bestanden</span>
        </label>
      )}
      {uploads.length > 0 && (
        <ul className="mt-3 space-y-2" data-testid={`${testid}-list`}>
          {uploads.map((u) => (
            <li key={u.id} className="flex items-center gap-3 rounded-lg bg-slate-50 px-3.5 py-2.5 text-[14px]">
              <span className="min-w-0 flex-1 truncate text-slate-700">{u.name}</span>
              {!u.path ? <Loader2 className="h-4 w-4 animate-spin text-slate-400" aria-label="Bezig met uploaden" /> : (
                <>
                  <span className="text-[12.5px] font-semibold text-maas">Toegevoegd</span>
                  <button type="button" onClick={() => setUploads((x) => x.filter((y) => y.id !== u.id))} aria-label={`Verwijder ${u.name}`}
                    className="flex h-8 w-8 items-center justify-center rounded-md text-slate-400 hover:bg-white hover:text-red-600" data-testid={`${testid}-remove`}><X className="h-4 w-4" /></button>
                </>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
